import { extractQueryListItems } from 'core/utils/apollo/extractListItems';
import { useGetSearchCandidateProfileSelectedItemsBySearchCandidateProfileSelectedQuery } from 'generated-graphql/hooks/apollo-hooks';
import { mapSourcingInternalSelectedCandidateProfilesToTableColumns } from '../maps';
import { useSourcingInternalCandidateProfileDuplicateCheck } from './useSourcingInternalCandidateProfileDuplicateCheck';

type UseSourcingInternalSelectedCandidatesForTableProps = {
  candidateBatchId: string | null;
  sessionId: string | null;
};

export const useSourcingInternalSelectedCandidatesForTable = ({
  candidateBatchId,
  sessionId
}: UseSourcingInternalSelectedCandidatesForTableProps) => {
  const {
    data: selectedCandidateProfilesData,
    loading: isLoading,
    refetch
  } = useGetSearchCandidateProfileSelectedItemsBySearchCandidateProfileSelectedQuery(
    {
      variables: {
        searchCandidateProfileSelectedId: sessionId || ''
      },
      skip: !sessionId
    }
  );

  const selectedCandidateProfiles = selectedCandidateProfilesData
    ? extractQueryListItems(selectedCandidateProfilesData)
    : [];

  const {
    isLoading: isDuplicateCheckLoading,
    duplicateCandidateProfileResults
  } = useSourcingInternalCandidateProfileDuplicateCheck({
    candidateProfileIds: selectedCandidateProfiles.map(
      (selectedCandidateProfile) =>
        selectedCandidateProfile.candidateProfile?.id ?? ''
    ),
    candidateBatchId
  });

  const mappedColumnData =
    mapSourcingInternalSelectedCandidateProfilesToTableColumns({
      data: selectedCandidateProfiles ?? [],
      duplicateCandidateProfileResults
    });

  const duplicateCandidateProfileIds = duplicateCandidateProfileResults
    .filter((result) => result.hasDuplicate)
    .map((result) => result.candidateProfileId);

  return {
    isSelectedCandidatesLoading: isLoading || isDuplicateCheckLoading,
    selectedCandidatesColumnData: mappedColumnData,
    selectedCandidatesFullData: selectedCandidateProfiles,
    duplicateCandidateProfileIds,
    refetchSelectedCandidateProfiles: refetch
  };
};
